import { render, staticRenderFns } from "./SSPasswordReminderView.vue?vue&type=template&id=38ff6d1f&scoped=true&"
import script from "./SSPasswordReminderView.vue?vue&type=script&lang=js&"
export * from "./SSPasswordReminderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ff6d1f",
  null
  
)

export default component.exports